import useSearchParams from "@/hooks/useSearchParams";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
export const usePagination = (param)=>{
    let { limit =24 , totalCount , isUseAsPath  } = param;
    const { push , query , asPath , pathname  } = useRouter();
    const searchParams = useSearchParams();
    const onChangePage = useCallback((page)=>{
        searchParams.delete("page");
        searchParams.append("page", page.toString());
        const path = isUseAsPath ? asPath.split("?")[0] : pathname;
        push({
            pathname: isUseAsPath ? path : pathname,
            query: searchParams.toString()
        }, undefined, {
            shallow: true,
            scroll: true
        });
    }, [
        query
    ]);
    const offset = useMemo(()=>{
        const page = Number(query.page) || 1;
        return limit * (page - 1);
    }, [
        query
    ]);
    const currentPage = Number(query.page) || 1;
    const totalPage = useMemo(()=>{
        return Math.ceil(totalCount / limit);
    }, [
        totalCount
    ]);
    return {
        onChangePage,
        offset,
        currentPage,
        totalPage
    };
};
